__turbopack_context__.v({
  "icon": "source-link-module__QVi77W__icon",
  "link": "source-link-module__QVi77W__link",
  "source": "source-link-module__QVi77W__source",
});
